/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { css } from "styled-components";
import styled from "styled-components";
import Colors from "constants/Colors";
import { Text } from "components/Text";
import { Breakpoints } from "constants/Breakpoints";
import Label from "components/Form/Label";

export const Line = styled.div`
  width: 98%;
  height: 1px !important;
  background-color: #c0c0c0;
  margin: 10px auto;
`;

export const Table = styled.table`
  border-collapse: collapse;
  padding: 0;
  width: 100%;
`;

export const TableHead = styled.thead`
  @media screen and (max-width: 600px) {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
`;

export const TableRow = styled.tr`
  ${(props) =>
    props.hightlight
      ? css`
          background-color: RGB(225, 244, 241);
          ${LabelEdit} {
            color: #000000;
            font-weight: bold;  
          }
        `
      : css`
          ${LabelEdit} {
            color: #595959; 
            }
        `}
`;

export const TableHeader = styled.th`
  ${({ minWidth }) => (minWidth ? `min-width: ${minWidth}px` : "")}
  ${({ maxWidth }) => (maxWidth ? `width: ${maxWidth}px` : "")}
  position: relative;
  vertical-align: top;
  padding: 5px;
  padding-left: 0px;
  ${({ right }) =>
    right ? "text-align: right !important" : "text-align: left"}

  &:nth-child(3), &:nth-child(4), &:nth-child(5), &:nth-child(6) { 
    padding-left: 5px;
  }

  span {
    font-size: 12px !important;
  }
`;

export const TableBody = styled.tbody`
  tr {
    border-bottom: 2px solid #e0e0e0;
  }
`;

export const TableCollum = styled.td`
  vertical-align: top;
  ${({ right }) =>
    right ? "text-align: right !important" : "text-align: left"}
  padding-bottom: 8px;
  padding-top: 8px;
  padding-right: 5px;
  display: table=cell;

  &:last-child {
    padding-right: 0px;
  }

  @media screen and (max-width: ${Breakpoints.sm}) {
    display: flex;
    max-width: unset !important;
    padding-top: 0px;
    padding-bottom: 2px;
    text-align: left;

    &:last-child {
      padding-bottom: 10px;
    }

    &:first-child {
      padding-top: 10px;
    }
  }
`;

export const InlineLabel = styled(Text)`
  display: inline-block;
  width: 30%;
  vertical-align: middle;
  padding-right: 5px;
  justify-content: start;
  align-items: flex-start;
  justify-self: flex-start;
  text-align: left;
  font-size: 12px;
  color: ${Colors.GRAY[3]};

  @media screen and (min-width: 600px) {
    display: none;
  }
`;

export const LabelEdit = styled(Label)`
  font-size: 12px;

  @media screen and (max-width: ${Breakpoints.sm}) {
    width: unset;
    text-align: center;
  }
`;
